<template>
    <div class="viewAllLoadsWrapper">

        <template v-if="!showCDS && !infoLoadsShow">

            <div class="date-picker-holder main">
                <div
                    id='select'
                    class="d-flex flex-row mb-auto pr-2 pl-2 control-item date-picker-holder_date-picker rel"
                >
                    <v-select
                        attach="#select"
                        v-model="selectedValue"
                        auto-select-first
                        :items="monthes"
                        :item-value="'date'"
                        :item-text="'name'"
                        @change="pickedMonth"
                        :menu-props="{ bottom: true, offsetY: true }"
                        label="Select month"
                    ></v-select>
                </div>
                <v-form
                    :disabled="role !== 3 && role !== 0"
                    class="ml-10 d-flex"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <v-text-field label="Base Rate" v-model="rateInfo" @change="changeRate"></v-text-field>
                    <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mt-3 ml-3 rate"
                        @click="validate"
                    >
                        Set Rate
                    </v-btn>
                </v-form>
            </div>

            <main-table
                v-if="forTable"
                :flag="flag"
                :pageTitle='title'
                :isPageTitle="false"
                :headers="headers"
                :listItems="forTable"
                :filtersList="getStatementsCreateFilter"
                :isCreate="false"
                :isSend="!!checkedArr.length"
                :is-export="false"
                sendText="Create statements"
                @updateBack="onBack"
                @updateClickButton="onClickButton"
                @updateSend="onSend"
                @updateCheckboxDS="onCheckbox"
                :changeCheckedAll="changeCheckedAll"
                @updateSearch="onFilter"
                @updateRefreshFilters="onFilter"
                @updateChangeSort="onFilter"
                isBackList
                send
            ></main-table>
        </template>

        <template v-if="showCDS && !infoLoadsShow">
            <ChosenDispatcherStatements
                :chosenDate="chosenDate ? chosenDate : selectedValue.date"
                v-on:backToMainTB="backToMainTB"
                v-on:backFromLoads="backFromLoads"
                v-on:fromChosenDispatchers="fromChosenDispatchers"
                :permissions="permissions"
                :info="info"
                :checkedArr="checkedArr"
                :selectedValue="selectedValue.name"
            ></ChosenDispatcherStatements>
        </template>

        <template v-if="infoLoadsShow && loadsInfo.dispatchers">
            <view-all-loads
                v-on:backFromLoads="backFromLoads"
                :permissions="permissions"
                :allLoadsInfo="loadsInfo.dispatchers"
                :filterLoads="loadsInfo.filter"
                :id="id"
                :loadInfoDate="loadInfoDate"
                loadsFlag="one"
            >
            </view-all-loads>
        </template>

    </div>
</template>
<script>
import Vuex, { mapActions, mapGetters } from "vuex";
import DispatcherInfo
from "../../../../store/modules/accounting/dispatchers-statements/dispatcher-statement-create-form/dispatcher-statement-create-form.module";
import ChosenDispatcherStatements from '../chosen-dispatchers-statement/chosen-dispatchers-statement.component';
import ViewAllLoads from '../view-all-loads/view-all-loads.component';
// constants
import { dispatchersStatementsCreateHeader } from "@/constants/defaultHeader";
// /dispatcher/statement/rate?date=2021-03-27&rate=${rate value}
const store = new Vuex.Store();
store.registerModule("DispatcherInfo", DispatcherInfo);
export default {
	components: {
		ChosenDispatcherStatements,
		ViewAllLoads
	},
	props: {},
	computed: {
		...mapGetters([
			'getStatementsCreateFilter',
			'permissions',
			'role'
		]),
		headers() {
			return dispatchersStatementsCreateHeader;
		},
		payBtnDisable() {
			const checkChecked = this.info.findIndex(item => item.checked);
			return checkChecked >= 0 ? false : true;
		},
		rateInfo() {
			return store.getters.getDispRate;
		},
		info() {
			return store.getters.getStatementsFormList;
		},
		monthes() {
			const reversed = store.getters.getStatementsMonthList.reverse();
			return reversed;
		},
		loadsInfo() {
			return store.getters.getLoadInfo;
		}
	},
	data() {
		return {
			title: 'Create Statement',
			flag: 'statementsCreateForm',
			id: null,
			loadInfoDate: null,
			valid: true,
			forTable: [],
			baseRate: '',
			selectedValue: { date: "2021-05-22", name: "June 2021" },
			date: new Date().toISOString().substr(0, 10),
			selected: [],
			listItems: [],
			checkedArr: [],
			chosenDate: "",
			showCDS: false,
			infoLoadsShow: false,
			chosenDispId: Number,
			changeCheckedAll: false,
			resetCheckedAll: false,
		};
	},
	methods: {
		...mapActions([
			'updateListDispStatementsCreateList',
		]),
		onBack() {
			this.$emit('backFromCreate');
		},
		async onFilter(info) {
			await this.updateListDispStatementsCreateList(info.filterModList);
		},
		onClickButton({ key, item }) {
			if (key === "openLoads") {
				this.openLoads(item.dispatcher_id);
			}
		},
		async openLoads(id) {
			this.id = id;
			this.loadInfoDate = this.chosenDate ? this.chosenDate : this.selectedValue.date;
			const payL = { id, date: this.loadInfoDate };
			await store.dispatch("getLoadInfo", payL).then(() => {
				this.infoLoadsShow = true;
				this.showCDS = false;
			});
		},
		onCheckbox({ item }) {
			// this.resetCheckedAll = !this.resetCheckedAll;
			this.changeCheckedAll = false;
			const index = this.checkedArr.findIndex( body => body.dispatcher_id === item.dispatcher_id );
			if (index === -1) {
				this.checkedArr.push(item);
			} else {
				this.checkedArr.splice(index, 1);
			}
		},
		onSend() {
			this.showCDS = true;
		},
		validate() {
			this.$refs.form.validate();
		},
		changeRate(value) {
			const date = this.selectedValue.date ? this.selectedValue.date : this.selectedValue;
			store.dispatch('getRateInfo', { value: value, date: date });
		},
		fillCheckedArr(item) {
			/*            this.checkedArr.push(item);
            store.dispatch('setCheck', item);*/
			this.checkedArr.push(item);
			store.dispatch('setCheck', item);
		},
		backToMainTB() {
			this.showCDS = false;
			this.checkedArr = [];
			this.$emit('backToMainTB');
		},
		backToList() {
			this.$emit('backFromCreate');
		},
		showCDSChange() {
			this.showCDS = true;
		},
		changeDate(date) {
			this.chosenDate = date;
		},
		async getList(date) {
			await store.dispatch("getDispInfo", date);
		},

		async getLoadInfo(dispId) {
			this.id = dispId;
			this.loadInfoDate = this.chosenDate ? this.chosenDate : this.selectedValue.date;
			const payL = { id: dispId, date: this.loadInfoDate };
			await store.dispatch("getLoadInfo", payL).then(() => {
				this.infoLoadsShow = true;
				this.showCDS = false;
			});
		},
		pickedMonth(item) {
			this.getList(item);
			this.chosenDate = item;
		},
		backFromLoads() {
			this.showCDS = false;
			this.infoLoadsShow = false;
			this.checkedArr = [];
		},
		fromChosenDispatchers(dispId) {
			this.getLoadInfo(dispId);
		}
	},
	mounted() {
		store.dispatch('getDispInfoDate').then(data => this.selectedValue = data.data.month[0]);
	},
	watch: {
		info(val) {
			this.forTable = val;
		}
	}
};
</script>
<style lang="scss" scoped>

.form-controls {
	display: flex;
	align-items: flex-end;
	flex-direction: column;

	.select-customer {
		margin-bottom: 4px;
	}

	.control-item {
		box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
		width: 100%;
	}
}

.date-picker-holder {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.date-picker-holder_date-picker {
	width: 10%;
}

.rel {
    position: relative;
}

.main {
    display: flex;
    flex-direction: row;
    justify-content: center;

    span {
        margin-left: 8vw;
    }

    .rate {
        width: 80px;
        background-image: linear-gradient(45deg, #339a09, #095600);
    }
}
.viewAllLoadsWrapper {
    height: 100%;
}
</style>
